'use strict';

var base = require('../product/base');
var focusHelper = require('../components/focus');
const gtmHelpers = require('../helpers/gtm');

$(document).ready(function () {
    checkForAttrNameElements();
    checkForChecked();
    $('[data-toggle="tooltip"]').tooltip();
});

$('.continue-browsing').click(function() {
    event.preventDefault();
    var homeUrl = $('.continue-browsing').data('href');
    window.location.href = homeUrl;
});

/**
 * Checks for all add-ons display names from the dropwdown-menu
 * and divides them into two separate sections
 */

function checkForAttrNameElements() {
    $('div.attrName').each(function () {
        const text = $(this).text();
        const regex = /\+([^\+]*)/;
        const match = regex.exec(text);
        if (match) {
            const textAfterPlusSign = match[1];
            const textBeforePlusSign = text.substring(0, text.indexOf('+'));
            $(this).text(textBeforePlusSign);
            $(this).siblings('div').text('+ $' + textAfterPlusSign);
        }
    });
}

/**
 * Displays the selected add-ons in a separate section
 */
 function checkForChecked() {
    $('.cart-product-card').each(function () {
        const checkboxes = this.querySelectorAll(".addonMenu input[type='checkbox']");
        const button = this.querySelector("#addonMenuButton");
        const selectedItems = this.querySelector("#selected-items");
        const selectedItemName = this.querySelector("#selected-item-name");
        const selectedItemCount = this.querySelector("#selected-item-count");
        let count = 0;

        for (const checkbox of checkboxes) {
            if (checkbox.checked) {
                updateButton(button);
                updateSelectedItems(selectedItems);
                updateSelectedItemName(selectedItemName, checkbox);
                count++;
            }
        }
        updateSelectedItemCount(selectedItemCount, count);
    });
}

 function updateButton(button) {
    if (button) {
        button.innerHTML = 'More add-ons <i class="fa fa-chevron-down"></i>';
    }
}

function updateSelectedItems(selectedItems) {
    if (selectedItems) {
        selectedItems.classList.add("d-flex");
        selectedItems.classList.add("flex-fill");
    }
}

function updateSelectedItemName(selectedItemName, checkbox) {
    if (selectedItemName) {
        const checkboxName = checkbox.nextElementSibling.innerHTML;
        const index = checkboxName.indexOf(":");
        selectedItemName.innerHTML = checkboxName.substring(0, index);
    }
}

function updateSelectedItemCount(selectedItemCount, count) {
    if (selectedItemCount) {
        if (count >= 2) {
            selectedItemCount.innerHTML = "+" + (count - 1) + " Add-ons";
        } else {
            selectedItemCount.innerHTML = "Add-on";
        }
    }
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            $('.cart-error').append(errorHtml);
        } else {
            $('.cart').empty().append('<div class="row"> ' +
                '<div class="col-12 text-center"> ' +
                '<h1>' + data.resources.emptyCartMsg + '</h1> ' +
                '</div> ' +
                '</div>'
            );
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            $('.minicart-quantity').empty().append(data.numItems);
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }

        $('.checkout-btn').addClass('disabled');
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 */
function updateCartTotals(data) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.custom-discount').empty().append(data.totals.customDiscount.formatted);
    $('.grand-total').empty().append(data.totals.grandTotal);
    $('.sub-total').empty().append(data.totals.customSubTotal.formatted);
    $('.add-ons').empty().append(data.totals.addOns.formatted);
    $('.passport-savings').empty().append(data.totals.passportSavings.formatted);
    $('.minicart-quantity').empty().append(data.numItems);
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems
    });
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }

    if (data.totals.shippingLevelDiscountTotal.value > 0) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }

    data.items.forEach(function (item) {
        if (data.totals.orderLevelDiscountTotal.value > 0) {
            $('.cart-totals').after(data.totals.allDiscountsHtml);
        }
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        $('.uuid-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.line-item-price-' + item.UUID + ' .unit-price').empty().append(item.renderedPrice);
        $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        $('.discount-uuid-' + item.UUID).empty().append(item.checkoutPrice.discountPrice);
        $('.total-uuid-' + item.UUID).empty().append(item.checkoutPrice.totalPrice);
    });
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">' +
                item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    if (lineItem != null) {
        $('.availability-' + lineItem.UUID).empty();

        if (lineItem.availability) {
            if (lineItem.availability.messages) {
                lineItem.availability.messages.forEach(function (message) {
                    messages += '<p class="line-item-attributes">' + message + '</p>';
                });
            }

            if (lineItem.availability.inStockDate) {
                messages += '<p class="line-item-attributes line-item-instock-date">' +
                    lineItem.availability.inStockDate +
                    '</p>';
            }
        }

        $('.availability-' + lineItem.UUID).html(messages);
    }
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) { // eslint-disable-line no-unused-vars
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    $('.card.product-info.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductLineItem(data, uuid) {
    $('.uuid-' + uuid).replaceWith(data.renderedTemplate);
}

/**
 * Generates the modal window on the first call.
 *
 */
function getModalHtmlElement() {
    if ($('#editProductModal').length !== 0) {
        $('#editProductModal').remove();
    }
    var htmlString = '<!-- Modal -->' +
        '<div class="modal fade" id="editProductModal" tabindex="-1" role="dialog">' +
        '<span class="enter-message sr-only" ></span>' +
        '<div class="modal-dialog quick-view-dialog">' +
        '<!-- Modal content-->' +
        '<div class="modal-content">' +
        '<div class="modal-header">' +
        '    <button type="button" class="close pull-right" data-dismiss="modal">' +
        '        <span aria-hidden="true">&times;</span>' +
        '        <span class="sr-only"> </span>' +
        '    </button>' +
        '</div>' +
        '<div class="modal-body"></div>' +
        '<div class="modal-footer"></div>' +
        '</div>' +
        '</div>' +
        '</div>';
    $('body').append(htmlString);
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.product-quickview');
    var footer = $html.find('.modal-footer').children();

    return {
        body: body,
        footer: footer
    };
}

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function fillModalElement(editProductUrl) {
    $('.modal-body').spinner().start();
    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success: function (data) {
            var parsedHtml = parseHtml(data.renderedTemplate);

            $('#editProductModal .modal-body').empty();
            $('#editProductModal .modal-body').html(parsedHtml.body);
            $('#editProductModal .modal-footer').html(parsedHtml.footer);
            $('#editProductModal .modal-header .close .sr-only').text(data.closeButtonText);
            $('#editProductModal .enter-message').text(data.enterDialogMessage);
            $('#editProductModal').modal('show');
            $('body').trigger('editproductmodal:ready');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDelete(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to add guest to product
 * @param {string} productID - pid
 * @param {string} uuid - uuid
 * @param {string} guestLastName - guest Last Name to be populated
 * @param {string} guestFirstName - guest First Name to be populated
 * @param {string} guestCpaoId - guest CpaoId to be populated
 * @param {string} customerId - customerid for validation
 */
function enterGuestInfo(actionUrl, productID, uuid, guestLastName, guestFirstName, guestCpaoId, customerId) {

    if (guestCpaoId != customerId) {
        $('#guestLastName').val(guestLastName);
        $('#guestFirstName').val(guestFirstName);
        $('#guestCpaoId').val(guestCpaoId);
    } else {
        $('#guestLastName').val('');
        $('#guestFirstName').val('');
        $('#guestCpaoId').val('');
    }

    var $submitAddGuest = $('.guest-form');

    $submitAddGuest.data('action', actionUrl);
    $submitAddGuest.data('pid', productID);
    $submitAddGuest.data('uuid', uuid);
    $submitAddGuest.data('customerId', customerId);

}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to add guest to product
 * @param {string} productID - pid
 * @param {string} uuid - uuid
 * @param {string} option - option Id
 * @param {string} value - option value
 */
function enterAddon(actionUrl, productID, uuid, option, value) {

    var $submitAddOn = $('.dropdown-item');

    $submitAddOn.data('action', actionUrl);
    $submitAddOn.data('pid', productID);
    $submitAddOn.data('uuid', uuid);
    $submitAddOn.data('option', option);
    $submitAddOn.data('value', value);

}

module.exports = function () {
    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDelete(actionUrl, productID, productName, uuid);
    });

    $('body').on('click', '.add-guest', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var uuid = $(this).data('uuid');
        var guestLastName = $(this).data('guestlastname');
        var guestFirstName = $(this).data('guestfirstname');
        var guestCpaoId = $(this).data('guestcpaoid');
        var customerId = $(this).data('customerid');
        enterGuestInfo(actionUrl, productID, uuid, guestLastName, guestFirstName, guestCpaoId, customerId);
    });

    $('body').on('click', '.remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var uuid = $(this).data('uuid');
        var option = $(this).data('option');
        var value = $(this).data('value');
        enterAddon(actionUrl, productID, uuid, option, value);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        gtmHelpers.onRemoveFromCart(data);
        confirmDelete(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('body').on('click', '.cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('.cart').empty().append('<div class="row"> ' +
                        '<div class="col-12 text-center"> ' +
                        '<h1>' + data.basket.resources.emptyCartMsg + '</h1> ' +
                        '</div> ' +
                        '</div>'
                    );
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    $('.minicart-quantity').empty().append(data.basket.numItems != 0 ? data.basket.numItems : '');
                    $('.minicart-link').attr({
                        'aria-label': data.basket.resources.minicartCountOfItems,
                        title: data.basket.resources.minicartCountOfItems
                    });
                    $('.minicart .popover').empty();
                    $('.minicart .popover').removeClass('show');
                    $('body').removeClass('modal-open');
                    $('html').removeClass('veiled');
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.uuid-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }
                    $('.uuid-' + uuid).remove();
                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    updateCartTotals(data.basket);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                gtmHelpers.onRemoveFromCart(data);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.cart-totals').after(data.totals.allDiscountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);
                validateBasket(data);
                $(this).data('pre-select-qty', quantity);

                $('body').trigger('cart:update', data);

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $('body').trigger('cart:beforeShippingMethodSelected');
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.cart-totals').after(data.totals.allDiscountsHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                }

                $('body').trigger('cart:shippingMethodSelected', data);
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.promo-code-form').submit(function (e) {
        e.preventDefault();
        $.spinner().start();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        if (!$('.coupon-code-field').val()) {
            $('.input-group').removeClass('border-dark').addClass('border-red');
            $('.promo-code-form .form-control').attr('aria-describedby', 'missingCouponCode');
            $('.coupon-missing-error').show();
            $.spinner().stop();
            $(".promo-code-form .form-control").on("click", function (event) {
                if (this.value === "") {
                    $('.input-group').removeClass('border-red').addClass('border-dark');
                    $('.coupon-missing-error').hide();
                    $('.coupon-error-message').empty();
                }
            })
            return false;
        }
        var $form = $('.promo-code-form');
        $('.input-group').removeClass('border-red').addClass('border-dark');
        $('.coupon-error-message').empty();
        $('body').trigger('promotion:beforeUpdate');

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $('.input-group').removeClass('border-dark').addClass('border-red');
                    $('.promo-code-form .form-control').attr('aria-describedby', 'invalidCouponCode');
                    $('.coupon-error-message').empty().append(data.errorMessage);
                    $(".promo-code-form .form-control").on("click", function (event) {
                        if (this.value === "") {
                            $('.input-group').removeClass('border-red').addClass('border-dark');
                            $('.coupon-missing-error').hide();
                            $('.coupon-error-message').empty();
                        }
                    })
                    $('body').trigger('promotion:error', data);
                } else {
                    if ($(".discounts-container")) {
                        $(".discounts-container").remove();
                    }
                    if ($(".inserted-coupons")) {
                        $(".inserted-coupons").remove();
                    }
                    $('.cart-totals').after(data.totals.allDiscountsHtml);
                    $('.insert-coupons').after(data.totals.discountExtensionHtml);
                    updateCartTotals(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);
                    $('body').trigger('promotion:success', data);
                }
                $('.form-control').blur().val('');
                $.spinner().stop();
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    $('body').on('click', '.cart-submit-addOn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var uuid = $(this).data('uuid');
        var option = $(this).data('option');
        var value = $(this).data('value');
        var url = $(this).data('action');

        var urlParams = {
            pid: productID,
            uuid: uuid,
            option: option,
            value: value
        };

        url = appendToUrl(url, urlParams);
        $.spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (!data.error){
                    updateProductLineItem(data, uuid);
                    updateCartTotals(data.cartModel);
                    checkForAttrNameElements();
                    checkForChecked();
                }

                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.guest-form').submit(function (e) {

        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var customerId = $(this).data('customerId');

        var urlParams = {
            pid: productID,
            uuid: uuid,
            customerId: customerId
        };
        url = appendToUrl(url, urlParams);

        var $form = $('.guest-form');

        $('.cart-error-messaging').empty();
        $.spinner().start();

        $.ajax({
            url: url,
            type: 'get',

            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    if (data.errorMessage === 'personalId') {
                        $('.guest-error.incorectId').hide();
                        $('.guest-error.personalid').hide();
                        $('.guest-error.onetimepurchase').hide();
                        $('.guest-error.notadmin').hide();
                        $('.guest-error.personalid').show();
                        $('.form-control.guestFirstName').addClass('is-invalid');
                        $('.form-control.guestLastName').addClass('is-invalid');
                        $('.form-control.guestCpaoId').addClass('is-invalid');
                    }
                    if (data.errorMessage === 'incorectId') {
                        $('.guest-error.personalid').hide();
                        $('.guest-error.incorectId').hide();
                        $('.guest-error.onetimepurchase').hide();
                        $('.guest-error.notadmin').hide();
                        $('.guest-error.incorectId').show();
                        $('.form-control.guestFirstName').addClass('is-invalid');
                        $('.form-control.guestLastName').addClass('is-invalid');
                        $('.form-control.guestCpaoId').addClass('is-invalid');
                    }

                    if (data.errorMessage === 'onetimepurchase') {
                        $('.guest-error.personalid').hide();
                        $('.guest-error.incorectId').hide();
                        $('.guest-error.notadmin').hide();
                        $('.guest-error.onetimepurchase').hide();
                        $('.guest-error.onetimepurchase').show();
                        $('.form-control.guestFirstName').addClass('is-invalid');
                        $('.form-control.guestLastName').addClass('is-invalid');
                        $('.form-control.guestCpaoId').addClass('is-invalid');
                    }

                    if (data.errorMessage === 'notadmin') {
                        $('.guest-error.personalid').hide();
                        $('.guest-error.incorectId').hide();
                        $('.guest-error.onetimepurchase').hide();
                        $('.guest-error.notadmin').hide();
                        $('.guest-error.notadmin').show();
                        $('.form-control.guestFirstName').addClass('is-invalid');
                        $('.form-control.guestLastName').addClass('is-invalid');
                        $('.form-control.guestCpaoId').addClass('is-invalid');
                    }

                } else {
                    $('.form-control.guestFirstName').removeClass('is-invalid');
                    $('.form-control.guestLastName').removeClass('is-invalid');
                    $('.form-control.guestCpaoId').removeClass('is-invalid');
                    $('.guest-error.personalid').hide();
                    $('.guest-error.incorectId').hide();
                    $('.guest-error.notadmin').hide();
                    $('#addGuestModal').modal('hide');
                    updateProductLineItem(data, uuid);
                    updateCartTotals(data.cartModel);
                    validateBasket(data.cartModel);
                }


                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.errorMessage);
                    $.spinner().stop();
                }
            }
        });

    });

    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);
        $('.coupon-' + uuid).remove();
        $('.coupon-missing-error').hide();
        $('.coupon-error-message').empty();
        $('.input-group').removeClass('border-green border-red').addClass('border-dark');
        $('.form-control').val('');
        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $('body').trigger('promotion:beforeUpdate');
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.coupon-uuid-' + uuid).remove();
                if ($(".discounts-container")) {
                    $(".discounts-container").remove();
                }
                $('.cart-totals').after(data.totals.allDiscountsHtml);
                updateCartTotals(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                validateBasket(data);
                $.spinner().stop();
                $('body').trigger('promotion:success', data);
            },
            error: function (err) {
                $('body').trigger('promotion:error', err);
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit', function (e) {
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        getModalHtmlElement();
        fillModalElement(editProductUrl);
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'true');
        $('#editProductModal .close').focus();
    });

    $('body').on('hidden.bs.modal', '#editProductModal', function () {
        $('#editProductModal').siblings().attr('aria-hidden', 'false');
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal',
            firstElementSelector: '.close',
            lastElementSelector: '.update-cart-product-global',
            nextToLastElementSelector: '.modal-footer .quantity-select'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        $('.update-cart-product-global', dialog).attr('disabled',
            !$('.global-availability', dialog).data('ready-to-order') ||
            !$('.global-availability', dialog).data('available')
        );
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) {
                    return $(item).data('available');
                });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) {
                    return $(item).data('ready-to-order');
                });

            $('.global-availability', dialog)
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : response.resources.info_selectforstock);
        } else {
            // single product
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.id);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('change', '.options-select', function () {
        var selectedOptionValueId = $(this).children('option:selected').data('value-id');
        $('.modal.show .update-cart-url').data('selected-option', selectedOptionValueId);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var selectedOptionValueId = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-option');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId
        };

        $(this).parents('.card').spinner().start();

        $('body').trigger('cart:beforeUpdate');

        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    $('#editProductModal').modal('hide');

                    $('.cart-totals').after(data.cartModel.totals.allDiscountsHtml);
                    updateCartTotals(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    $('body').trigger('cart:update', data);

                    $.spinner().stop();
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    // disable continue to checkout if button is disabled
    $('.btn-pricing-cart').on('click', function(e) {
        if ($(this).hasClass('disabled')) {
            e.preventDefault();
        }
    })

    base.selectAttribute();
    base.colorAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
};